import { render, staticRenderFns } from "./TodoInspection.vue?vue&type=template&id=c37a816a&scoped=true&"
import script from "./TodoInspection.vue?vue&type=script&lang=js&"
export * from "./TodoInspection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37a816a",
  null
  
)

export default component.exports